var audio = null;

export function playSound(url) {
  audio = audio || new Audio(url);
  audio.play();
}

export function setSound(url) {
  audio = new Audio(url);
}
